var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragDropLargeImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 364,
    height: 44,
    viewBox: "0 0 364 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179053"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6749",
    style: {
      fill: "#f3f6f9",
      stroke: "#203662",
      strokeDasharray: "4 2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h364v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h363v43H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 172048"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21136",
    d: "M17.767 11.534A1.767 1.767 0 1 0 16 9.767a1.767 1.767 0 0 0 1.767 1.767zm0-2.356a.589.589 0 1 1-.589.589.589.589 0 0 1 .589-.589z",
    transform: "translate(166.456 8.356)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21135",
    d: "M3.178 20v1.178h2.7L2 25.057l.833.833 3.879-3.879v2.7H7.89V20z",
    transform: "translate(172.209 3.425)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21137",
    d: "M16.959 4H5.178A1.178 1.178 0 0 0 4 5.178v5.89h1.178v-5.89h11.781v8.936L14.844 12a1.178 1.178 0 0 0-1.661 0l-.937.937L8.613 9.3l-.834.834 2.111 2.113 1.526 1.526a1.178 1.178 0 0 0 1.661 0l.937-.937 2.945 2.945v1.178h-5.89v1.178h5.89a1.178 1.178 0 0 0 1.178-1.178V5.178A1.178 1.178 0 0 0 16.959 4z",
    transform: "translate(171.387 10)",
    style: {
      fill: "#203662"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDropLargeImage);
export default __webpack_public_path__ + "static/media/drag_drop_large_image.0b24be2f0235e71376a82d932f7cf9f3.svg";
export { ForwardRef as ReactComponent };